/**
 * A press is a tap until it travels further than this (CSS pixels). A finger never lands still: a
 * tap on a phone moves a few pixels between touching and lifting, and the editor read every one of
 * those moves as a drag, so the tap that should open a box for typing or the adoption sheet moved
 * the box a pixel instead (tester reports, 19 Oct 2026, iPhone).
 */
export const TAP_SLOP_PX = 8

export interface PressPoint {
  readonly x: number
  readonly y: number
}

/** Whether a press from `start` has travelled far enough to be a drag rather than a tap. */
export function pressTravelled(
  start: PressPoint,
  current: PressPoint,
  slop: number = TAP_SLOP_PX,
): boolean {
  return Math.hypot(current.x - start.x, current.y - start.y) >= slop
}
